// extracted by mini-css-extract-plugin
export var infoItem = "_qz-2";
export var title = "_qz-0";
export var value = "_qz-1";